<div class="plugin">
  <div class="plugin__tabs" role="tablist">
    <button
      type="button"
      role="tab"
      *ngFor="let guide of guides"
      class="btn plugin__tab"
      [class.btn-primary]="activeProvider === guide.provider"
      [class.btn-outline-primary]="activeProvider !== guide.provider"
      [attr.aria-selected]="activeProvider === guide.provider"
      (click)="selectProvider(guide.provider)"
    >
      {{ guide.label }}
    </button>
  </div>

  <div class="plugin__steps">
    <p class="plugin__steps-label">{{ activeGuide.label }} — conectar a AyA</p>

    <ol class="plugin__steps-list">
      <li class="plugin__step" *ngFor="let step of activeGuide.steps; let i = index">
        <span class="plugin__step-badge">{{ i + 1 }}</span>
        <span class="plugin__step-text" [innerHTML]="step"></span>
      </li>
    </ol>

    <p class="plugin__note" *ngIf="activeGuide.note">
      {{ activeGuide.note }}
      <a
        *ngIf="activeGuide.docs as docs"
        [href]="docs.url"
        target="_blank"
        rel="noopener noreferrer"
      >{{ docs.label }}</a>.
    </p>
  </div>
</div>
